var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { PstParserService } from 'pst/services';
import * as fromPst from 'pst/store/pst.store';
import { combineLatest } from 'rxjs';
import { LoggerService, LookupDataService } from 'shared/services';
import { BasePstComponent } from '../base-pst.component';
var MessageComponent = /** @class */ (function (_super) {
    __extends(MessageComponent, _super);
    function MessageComponent(loggerService, modalService, pstStore, pstParser, lookupService) {
        var _this = _super.call(this, loggerService, modalService) || this;
        _this.pstStore = pstStore;
        _this.pstParser = pstParser;
        _this.lookupService = lookupService;
        return _this;
    }
    MessageComponent.prototype.ngOnDestroy = function () { };
    MessageComponent.prototype.ngOnInit = function () {
        var _this = this;
        var result$ = this.pstStore.select(fromPst.selectInProgressPst);
        var tree$ = this.pstStore.select(fromPst.selectPstTree);
        var tooltips$ = this.lookupService.getPstTooltips();
        combineLatest(result$, tree$, tooltips$, function (result, tree, tooltips) {
            return { result: result, tree: tree, tooltips: tooltips };
        })
            .pipe(this.scavenger.collect())
            .subscribe(function (_a) {
            var result = _a.result, tree = _a.tree, tooltips = _a.tooltips;
            _this.tree = tree;
            if (!_this.tree) {
                return;
            }
            _super.prototype.initContent.call(_this, null, tooltips, tree.node.nodeId);
            _this.heading = _this.pstParser.parseParameterizedString(tree.node.nodeHeading, result);
            _this.description = tree.node.nodeDescription;
        });
    };
    return MessageComponent;
}(BasePstComponent));
export { MessageComponent };
